import SunsetTourBike from '../img/experience/3.jpg';

const SunsetTourVankorByBike = {
	id: 3, img: SunsetTourBike, permalink: "the-sunset-tour-vancouver-by-bike", title: "The Sunset Tour - Vancouver By Bike", city: "Eintertaintment-Canada", location: "Vancouver, Canada", star: 4.85, cost: 176
};
export default SunsetTourVankorByBike;